import React, { useEffect, useState } from 'react';
import {
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Typography,
  IconButton,
  Dialog,
  InputAdornment,
} from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import InsertLinkIcon from '@material-ui/icons/InsertLink';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import webStorage from '@/utils/storageManager';
import ClearIconML from '@/components/ClearIconML/index';
import {
  UploadImageCom,
  TextFieldCom,
  SelectFieldCom,
  CheckBoxFieldCom,
} from '../FormType';
import DialogML from '@/components/DialogML';
import DataTableNativeML from '@/components/DataTableNativeML';
import { uploadFile } from '@/utils/uploadImg';
import ClearIcon from '@material-ui/icons/Clear';
import PrizesListFormMLStyled from './PrizesListFormMLStyles';

function SimpleDialog(props) {
  const { onClose, selectedValue, open, imgSrc } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <img alt="" src={imgSrc} />
    </Dialog>
  );
}
let timer = null;
export default ({
  data,
  id,
  handleDelete,
  resetPrize,
  queryType = false,
  probabilityList,
  giftList = [],
  checkForm,
  formIds,
  checkFormIds,
  getGiftQueryPage,
  total,
  updateFormFun,
  prizesList,
}) => {
  //礼品类别
  const GIFT_TYPE = webStorage.get('DICTOBJ')?.GIFT_TYPE;
  const GIFT_TYPE_SELECT =
    GIFT_TYPE &&
    GIFT_TYPE.map((item) => ({
      name: item.nameZh,
      value: item.dictCode,
    }));
  //奖品发放类型
  const PRIZE_SEND_TYPE = webStorage.get('DICTOBJ')?.PRIZE_SEND_TYPE;
  const PRIZE_SEND_TYPE_SELECT =
    PRIZE_SEND_TYPE &&
    PRIZE_SEND_TYPE.map((item) => ({
      name: item.nameZh,
      value: item.dictCode,
    }));
  //礼品类目
  const GIFT_CATEGORY = webStorage.get('DICTOBJ')?.GIFT_CATEGORY;
  const GIFT_CATEGORY_SELECT =
    GIFT_CATEGORY &&
    GIFT_CATEGORY.map((item) => ({
      name: item.nameZh,
      value: item.dictCode,
    }));
  const {
    handleSubmit,
    control,
    setValue,
    errors,
    getValues,
    watch,
    clearErrors,
  } = useForm();
  const watchAllFields = watch(); //watch里不传参数监听所有
  const [images, setImages] = useState();
  const [open, setOpen] = useState(true);
  //1 -> 初始状态 2 -> 没有通过校验 3 -> 通过校验
  const [firstStatus, setFirstStatus] = useState(1);
  const [checkButtonStatus, setCheckButtonStatus] = useState(true);
  const [dialogStatus, setDialogStatus] = useState(false);
  // const [productTitle, setProductTitle] = useState(''); //选择商品商品标题
  const [chooseIdState, setChooseIdState] = useState();
  const [dOpen, setDOpen] = useState(false);
  useEffect(() => {
    for (let key in data) {
      if (key === 'probability') {
        const probabilityData = data.probability;
        probabilityData.forEach((item) => {
          setValue('level' + item.level, item.probability);
        });
      } else if (key === 'picUrl') {
        if (
          data.picUrl &&
          (data.picUrl.indexOf('http') > -1 ||
            data.picUrl.indexOf('https') > -1)
        ) {
          const imgUrl = data.picUrl ? data.picUrl.split('/') : [];
          imgUrl.length > 0 &&
            setValue(
              'picUrl',
              `${imgUrl[imgUrl.length - 2]}/${imgUrl[imgUrl.length - 1]}`,
            );
        } else {
          setImages(data.picUrlImgs);
          setValue('picUrlImgs', data.picUrlImgs);
          setValue('picUrl', data.picUrl);
        }
      } else {
        setValue(key, data[key]);
      }
    }
    if (
      data.picUrl &&
      (data.picUrl.indexOf('http') > -1 || data.picUrl.indexOf('https') > -1)
    ) {
      setImages([{ data_url: data.picUrl }]);
    }
  }, [data, setValue]);

  const onSubmitSuccess = (formData) => {
    setFirstStatus(3);
    setCheckButtonStatus(false);
    updateFormFun && updateFormFun({ formData, id });
    return false;
  };
  const onSubmitError = (d) => {
    JSON.stringify(d) !== '{}' && setFirstStatus(2);
    !firstStatus && setFirstStatus(true);
  };

  const handleOpen = () => {
    setOpen(!open);
  };
  useEffect(() => {
    (watchAllFields.prizeTitle ||
      watchAllFields.sendType ||
      watchAllFields.prizeType ||
      watchAllFields.prizeNum ||
      watchAllFields.prizeLevel ||
      watchAllFields.prizeDescription ||
      watchAllFields.prizeAmount ||
      watchAllFields.picUrl ||
      watchAllFields.level1 ||
      watchAllFields.level2 ||
      watchAllFields.level3 ||
      watchAllFields.level4) &&
      !checkButtonStatus &&
      setCheckButtonStatus(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    watchAllFields.prizeTitle,
    watchAllFields.sendType,
    watchAllFields.prizeType,
    watchAllFields.prizeNum,
    watchAllFields.prizeLevel,
    watchAllFields.prizeDescription,
    watchAllFields.prizeAmount,
    watchAllFields.picUrl,
    watchAllFields.level1,
    watchAllFields.level2,
    watchAllFields.level3,
    watchAllFields.level4,
  ]);

  const onCloseDialog = (v) => {
    if (
      v &&
      ((data.chooseIds.length === 0 &&
        JSON.stringify(chooseIdState) !== '{}') ||
        (data.chooseIds.length > 0 &&
          data.chooseIds[0].id !== chooseIdState?.id))
    ) {
      updateFormFun &&
        updateFormFun({
          formData: {
            chooseIds:
              chooseIdState && JSON.stringify(chooseIdState) !== '{}'
                ? [chooseIdState]
                : [],
          },
          id,
        });
      if (chooseIdState && JSON.stringify(chooseIdState) !== '{}') {
        setValue('prizeTitle', chooseIdState.title);
        setValue('prizeType', chooseIdState.type);
        setValue('prizeAmount', chooseIdState.price);
        setValue('prizeNum', chooseIdState.stock);
        resetPrize && resetPrize(data.id);
      } else {
        setValue('prizeTitle', '');
        setValue('prizeType', '');
        setValue('prizeAmount', '');
        setValue('prizeNum', '');
        resetPrize && resetPrize(data.id);
      }
    }
    setDialogStatus(false);
  };
  //选择商品的头部
  const labelCom = (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Typography
            variant="body1"
            className="coupon-dialog-title-init-style"
          >
            选择商品
          </Typography>
        </Box>
        {onCloseDialog ? (
          <IconButton aria-label="close" onClick={() => onCloseDialog()}>
            <CloseIcon className="coupon-dialog-close-icon-init-style" />
          </IconButton>
        ) : null}
      </Box>
    </Box>
  );

  const columns = [
    {
      type: 'checkbox',
      width: '100',
      onChange: (a, b, c) => {
        setChooseIdState(c.length > 0 ? c[0] : null);
      },
    },
    {
      title: '商品类别',
      id: 'type',
      align: 'center',
      width: 147,
      render: (d) => {
        const s = GIFT_TYPE_SELECT.filter((item) => item.value === d.type);
        return s[0]?.name;
      },
    },
    {
      title: '商品类目',
      id: 'category',
      align: 'center',
      width: 147,
      render: (d) => {
        const s = GIFT_CATEGORY_SELECT.filter(
          (item) => item.value === d.category,
        );
        return s[0]?.name;
      },
    },
    {
      title: '商品标题',
      id: 'title',
      align: 'center',
      width: 400,
    },
  ];
  const storesContent = () => {
    return (
      <Box>
        <form>
          <Box display="flex" gap="0 25px" mt={2}>
            <Box flex="1">
              <FormControl variant="standard" fullWidth>
                <InputLabel>商品类别</InputLabel>
                <Controller
                  render={(pr) => (
                    <SelectFieldCom
                      pr={pr}
                      typeList={GIFT_TYPE_SELECT}
                      queryType={queryType}
                      value={data.type}
                      guid={data.id}
                      resetPrize={(a, b, c) => {
                        updateFormFun &&
                          updateFormFun({
                            formData: { type: c, pageNum: 1 },
                            id,
                          });
                      }}
                      restKey="type"
                    />
                  )}
                  label="商品类别"
                  name="type"
                  control={control}
                />
                <ClearIconML
                  clearValue={getValues('type')}
                  handleClick={() => {
                    setValue('type', '');
                    updateFormFun &&
                      updateFormFun({ formData: { type: '' }, id });
                  }}
                ></ClearIconML>
              </FormControl>
            </Box>
            <Box flex="1">
              <FormControl variant="standard" fullWidth>
                <InputLabel>商品类目</InputLabel>
                <Controller
                  render={(pr) => (
                    <SelectFieldCom
                      pr={pr}
                      typeList={GIFT_CATEGORY_SELECT}
                      queryType={queryType}
                      value={data.category}
                      guid={data.id}
                      resetPrize={(a, b, c) => {
                        updateFormFun &&
                          updateFormFun({
                            formData: { category: c, pageNum: 1 },
                            id,
                            isCheckForm: true,
                          });
                      }}
                      restKey="category"
                    />
                  )}
                  label="商品类目"
                  name="category"
                  control={control}
                />
                <ClearIconML
                  clearValue={getValues('category')}
                  handleClick={() => {
                    setValue('category', '');
                    updateFormFun &&
                      updateFormFun({
                        formData: { category: '' },
                        id,
                        isCheckForm: true,
                      });
                  }}
                ></ClearIconML>
              </FormControl>
            </Box>
            <Box flex="1">
              <Controller
                render={(pr) => (
                  <TextField
                    fullWidth
                    label="商品标题"
                    variant="standard"
                    value={pr.value ?? data.title}
                    onChange={(e) => {
                      // handleProductTitle(e.target.value);
                      clearTimeout(timer);
                      timer = setTimeout(() => {
                        updateFormFun &&
                          updateFormFun({
                            formData: { title: e.target.value, pageNum: 1 },
                            id,
                            isCheckForm: true,
                          });
                      }, 800);
                      return pr.onChange(e.target.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              updateFormFun &&
                                updateFormFun({
                                  formData: { title: '' },
                                  id,
                                  isCheckForm: true,
                                });
                              setValue('title', '');
                            }}
                            edge="end"
                            disabled={queryType === 'detail'}
                          >
                            {getValues('title') && (
                              <ClearIcon className="clear-icon" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                control={control}
                name="title"
              />
            </Box>
          </Box>
        </form>
        <Box>
          <DataTableNativeML
            paging={true}
            columns={columns}
            data={giftList}
            columnKey="id"
            total={total}
            devicesMinWidth="auto"
            chooseIds={data.chooseIds.length > 0 ? [data.chooseIds[0].id] : []}
            page={{
              pageSize: data.pageSize,
              pageNum: data.pageNum,
            }}
            // eslint-disable-next-line react/jsx-no-duplicate-props
            changePage={(p) => {
              updateFormFun &&
                updateFormFun({
                  formData: { pageNum: p.pageNum, pageSize: p.pageSize },
                  id,
                  isCheckForm: true,
                });
            }}
            singleSelect={true}
          />
        </Box>
      </Box>
    );
  };

  const handleShowProduct = () => {
    setDialogStatus(true);
    getGiftQueryPage &&
      getGiftQueryPage({
        title: data.title,
        pageNum: data.pageNum,
        pageSize: data.pageSize,
        category: data.category,
        type: data.type,
        id,
      });
  };

  useEffect(() => {
    getGiftQueryPage &&
      getGiftQueryPage({
        title: data.title,
        pageNum: data.pageNum,
        pageSize: data.pageSize,
        category: data.category,
        type: data.type,
        id,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.title, data.category, data.type, data.pageNum, data.pageSize]);

  const handlePreview = () => {
    setDOpen(true);
  };
  const handleClose = () => {
    setDOpen(false);
  };
  useEffect(() => {
    clearErrors();
  }, [clearErrors, prizesList.length]);

  const handleSetImages = (imgData) => {
    const file =
      Array.isArray(imgData) && imgData.length > 0 ? imgData[0].file : '';
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('isFixedName', false);
      formData.append('isPublic', false);
      formData.append('bucket', 'GIFT-IMAGE');
      uploadFile('/common/upload', formData, (res) => {
        if (res.code === 0) {
          const url = res.data.url;
          resetPrize && resetPrize(id, 'picUrl', url);
          setValue('picUrl', url, {
            shouldValidate: true,
          });
          setValue('picUrlImgs', imgData);
          setImages(imgData);
        }
      });
    }
  };
  return (
    <PrizesListFormMLStyled>
      <Box
        mb={0.5}
        borderRadius="8px"
        border="1px solid #1565C0"
        padding="16px 56px 16px 18px"
      >
        <form onSubmit={handleSubmit(onSubmitSuccess, onSubmitError)}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            onClick={handleOpen}
            height="24px"
          >
            <Box display="flex" alignItems="center">
              {firstStatus === 1 ? (
                <CheckCircleIcon
                  sx={{ width: '20px', height: '20px', color: '#666666' }}
                />
              ) : firstStatus === 2 ? (
                <ErrorOutlineIcon
                  sx={{ width: '20px', height: '20px', color: '#F44336' }}
                />
              ) : (
                <CheckCircleIcon
                  sx={{ width: '20px', height: '20px', color: '#1565C0' }}
                />
              )}
              {getValues('prizeLevel') && (
                <Box
                  sx={{
                    height: '24px',
                    fontSize: '16px',
                    color: '#000000',
                    fontWeight: '400',
                    lineHeight: '25px',
                    marginLeft: '18px',
                  }}
                >
                  {getValues('prizeLevel')}
                </Box>
              )}
              {getValues('prizeTitle') && (
                <Box
                  sx={{
                    height: '24px',
                    fontSize: '16px',
                    color: '#000000',
                    fontWeight: '400',
                    lineHeight: '25px',
                    marginLeft: '22px',
                  }}
                >
                  {getValues('prizeTitle')}
                </Box>
              )}
              {formIds.indexOf(id) === -1 && (
                <Box
                  sx={{
                    height: '24px',
                    fontSize: '16px',
                    color: '#D10000',
                    fontWeight: '400',
                    lineHeight: '25px',
                    marginLeft: '22px',
                  }}
                >
                  暂未保存
                </Box>
              )}
            </Box>
            <ExpandLessIcon
              className={open ? 'open-icon-tran' : ''}
              sx={{ width: '16px', height: '16px', color: '#616161' }}
            />
          </Box>
          {/*表单部分s*/}
          <Box
            mt={open ? 3 : 0}
            mb={open ? 3 : 0}
            pl={4.75}
            height={open ? 'auto' : '0px'}
            overflow={open ? 'initial' : 'hidden'}
            display="flex"
            gap="0 40px"
            justifyContent="space-between"
          >
            {/*左*/}
            <Box width="140px">
              <UploadImageCom
                uW="140"
                uH="140"
                iW="140"
                iH="140"
                handleSetImages={handleSetImages}
                images={images}
                label="背景图片设定"
                tips="建议上传.png格式图片"
                tipsAlign="left"
                required={true}
                handlePreview={handlePreview}
                queryType={queryType}
              />
              {errors.picUrl && (
                <Box mt={1}>
                  <Box className="input-error-style">请选择背景图片设定</Box>
                </Box>
              )}
            </Box>
            {/*中*/}
            <Box flex={1} pt={1}>
              {/*1s*/}
              <Box
                display="flex"
                justifyContent="space-between"
                gap="0 25px"
                alignItems="center"
              >
                {queryType !== 'detail' && (
                  <Button
                    variant="contained"
                    startIcon={<InsertLinkIcon />}
                    sx={{
                      width: '118px',
                      borderRadius: '24px',
                      height: '34px',
                    }}
                    onClick={handleShowProduct}
                  >
                    关联奖品
                  </Button>
                )}
                <Box flex="1">
                  <Controller
                    render={(pr) => (
                      <TextFieldCom
                        pr={pr}
                        id="prizeTitle"
                        errors={errors}
                        label="奖品标题"
                        queryType={queryType}
                        setValue={setValue}
                        resetPrize={resetPrize}
                        restKey="prizeTitle"
                        guid={data.id}
                      />
                    )}
                    control={control}
                    name="prizeTitle"
                    rules={{
                      required: true,
                    }}
                  />
                </Box>
                <Box flex="1">
                  <Controller
                    render={(pr) => (
                      <TextFieldCom
                        pr={pr}
                        id="prizeLevel"
                        errors={errors}
                        label="奖品等级"
                        queryType={queryType}
                        setValue={setValue}
                        resetPrize={resetPrize}
                        restKey="prizeLevel"
                        guid={data.id}
                      />
                    )}
                    control={control}
                    name="prizeLevel"
                    rules={{
                      required: true,
                    }}
                  />
                </Box>
              </Box>
              {/*1e*/}
              {/*2s*/}
              <Box mt={4} mb={5.75} className="input-height-auto">
                <Controller
                  render={(pr) => (
                    <TextFieldCom
                      pr={pr}
                      id="prizeDescription"
                      errors={errors}
                      label="奖品说明"
                      queryType={queryType}
                      setValue={setValue}
                      resetPrize={resetPrize}
                      restKey="prizeDescription"
                      guid={data.id}
                      multiline
                      rows={3}
                    />
                  )}
                  control={control}
                  name="prizeDescription"
                  rules={{
                    required: true,
                  }}
                />
              </Box>
              {/*2e*/}
              {/*3s*/}
              <Box display="flex" gap="0 24px">
                <Box flex="1">
                  <FormControl variant="standard" sx={{ width: '100%' }}>
                    <InputLabel>
                      <span style={{ color: 'red' }}>*</span>奖品类型
                    </InputLabel>
                    <Controller
                      render={(pr) => (
                        <SelectFieldCom
                          pr={pr}
                          typeList={GIFT_TYPE_SELECT}
                          queryType={queryType}
                          errors={errors}
                          guid={data.id}
                          resetPrize={resetPrize}
                          restKey="prizeType"
                          disabled={data.chooseIds.length > 0}
                        />
                      )}
                      label="奖品类型"
                      name="prizeType"
                      variant="standard"
                      control={control}
                      rules={{
                        required: true,
                      }}
                    />
                    <ClearIconML
                      clearValue={false}
                      handleClick={() => {
                        setValue('prizeType', '');
                        resetPrize && resetPrize(data.id, 'prizeType', '');
                      }}
                    ></ClearIconML>
                  </FormControl>
                </Box>
                <Box flex="1">
                  <FormControl variant="standard" sx={{ width: '100%' }}>
                    <InputLabel>
                      <span style={{ color: 'red' }}>*</span>奖品发放形式
                    </InputLabel>
                    <Controller
                      render={(pr) => (
                        <SelectFieldCom
                          pr={pr}
                          id="sendType"
                          typeList={PRIZE_SEND_TYPE_SELECT}
                          queryType={queryType}
                          guid={data.id}
                          resetPrize={resetPrize}
                          restKey="sendType"
                        />
                      )}
                      name="sendType"
                      variant="standard"
                      control={control}
                      rules={{
                        required: true,
                      }}
                    />
                    <ClearIconML
                      clearValue={false}
                      handleClick={() => {
                        setValue('sendType', '');
                        resetPrize && resetPrize(data.id, 'sendType', '');
                      }}
                    ></ClearIconML>
                  </FormControl>
                </Box>
                <Box flex="1">
                  <Controller
                    render={(pr) => (
                      <TextFieldCom
                        pr={pr}
                        id="prizeAmount"
                        errors={errors}
                        label="奖品价值"
                        queryType={queryType}
                        setValue={setValue}
                        resetPrize={resetPrize}
                        restKey="prizeAmount"
                        guid={data.id}
                        isPositiveNumber={true}
                        isNumber={true}
                      />
                    )}
                    control={control}
                    name="prizeAmount"
                    rules={{
                      required: true,
                    }}
                  />
                </Box>
                <Box flex="1">
                  <Controller
                    render={(pr) => (
                      <TextFieldCom
                        pr={pr}
                        id="prizeNum"
                        errors={errors}
                        label="奖品数量"
                        queryType={queryType}
                        setValue={setValue}
                        resetPrize={resetPrize}
                        restKey="prizeNum"
                        guid={data.id}
                        isPositiveNumber={true}
                        isNumber={true}
                      />
                    )}
                    control={control}
                    name="prizeNum"
                    rules={{
                      required: true,
                    }}
                  />
                </Box>
              </Box>
              {/*3e*/}
            </Box>
            {/*右*/}
            <Box width="377px">
              <Box mb={2} color="#212100" fontSize="12px">
                <span style={{ color: 'red' }}>*</span> 中奖概率设置
              </Box>
              <Box
                sx={{ padding: '24px 20px' }}
                display="flex"
                flexWrap="wrap"
                gap="20px 0"
                bgcolor="rgba(21, 101, 192, 0.03)"
                height="122px"
              >
                {probabilityList.length > 0 &&
                  probabilityList.map((item, index) => {
                    return (
                      <Box
                        width="50%"
                        key={index}
                        display="flex"
                        justifyContent="space-between"
                        className="probability-list-wrap"
                        pr={index === 0 || index === 2 ? 3 : 0}
                        pl={index === 1 || index === 3 ? 3 : 0}
                      >
                        <Box fontSize="16px" fontWeight="400" color="#404041">
                          {item.name}
                        </Box>
                        <Box flex="1">
                          <Controller
                            render={(pr) => (
                              <TextFieldCom
                                pr={pr}
                                id={'level' + item.level}
                                pId={data.id}
                                errors={errors}
                                label=""
                                queryType={queryType}
                                setValue={setValue}
                                resetPrize={resetPrize}
                                guid={item.level}
                                restKey="probability"
                                isPositiveNumber={true}
                                isNumber={true}
                                endAdornment="%"
                              />
                            )}
                            control={control}
                            name={'level' + item.level}
                            rules={{
                              required: true,
                            }}
                          />
                        </Box>
                      </Box>
                    );
                  })}
              </Box>
              <Box
                display="flex"
                marginTop="38px"
                justifyContent="space-between"
              >
                <Box className="checkbox-radio-disabled-color checkBox-no-label">
                  <Controller
                    render={(pr) => (
                      <CheckBoxFieldCom
                        pr={pr}
                        label={
                          <span>
                            默认奖品
                            <span style={{ fontSize: '12px' }}>
                              （用于补充已超出中奖上限的奖品）
                            </span>
                          </span>
                        }
                        queryType={queryType}
                        resetPrize={resetPrize}
                        restKey="isLastPrize"
                        guid={data.id}
                        onCallBack={() => {}}
                      />
                    )}
                    control={control}
                    name="isLastPrize"
                  />
                </Box>
                {queryType !== 'detail' && (
                  <Box display="flex" justifyContent="flex-end">
                    {checkFormIds.indexOf(id) === -1 && (
                      <Box position="relative" className="delete-wrap">
                        <Button
                          sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            opacity: 0,
                            width: '34px',
                            minWidth: '34px',
                          }}
                          type="submit"
                        >
                          提交
                        </Button>
                        <CheckIcon width="100%" height="100%" />
                      </Box>
                    )}
                    {Array.isArray(prizesList) && prizesList.length > 1 && (
                      <Box
                        className="delete-wrap"
                        ml={2}
                        onClick={() => {
                          handleDelete(id);
                          checkForm(id);
                          setImages();
                          setValue('picUrl', '');
                        }}
                      >
                        <DeleteForeverIcon width="100%" height="100%" />
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
          {/*表单部分e*/}
          {/* <Box onClick={() => handleDelete(id)}>删除</Box> */}
          <Box>
            <Controller
              render={(pr) => (
                <TextField
                  sx={{ display: 'none' }}
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                  value={pr.value ?? ''}
                  error={Boolean(errors.picUrl)}
                />
              )}
              control={control}
              name="picUrl"
              rules={{
                required: true,
              }}
            />
            <Controller
              render={(pr) => (
                <TextField
                  sx={{ display: 'none' }}
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                  value={pr.value ?? ''}
                  error={Boolean(errors.picUrl)}
                />
              )}
              control={control}
              name="picUrlImgs"
            />
          </Box>
        </form>
        <DialogML
          open={dialogStatus}
          title={labelCom}
          minheightinit={600}
          minwidthinit={800}
          describe={storesContent()}
          handleClose={onCloseDialog}
          specilaAlgorithmLabValue={'ok'}
        />
        <SimpleDialog
          open={dOpen}
          onClose={handleClose}
          imgSrc={
            Array.isArray(images) && images.length > 0 ? images[0].data_url : ''
          }
        />
      </Box>
    </PrizesListFormMLStyled>
  );
};
